function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import serverSideCalculations from 'shared/graphql/calculations/mutations/server-side-calculations.gql';
import { ecommCalculationsInput } from '../helpers/calculations/helpers';
var handleLegacyCalculationsRequest = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(param) {
        var apolloClient, legacyInput;
        return _ts_generator(this, function(_state) {
            apolloClient = param.apolloClient, legacyInput = param.legacyInput;
            return [
                2,
                apolloClient.mutate({
                    mutation: serverSideCalculations,
                    variables: {
                        input: legacyInput
                    }
                })
            ];
        });
    });
    return function handleLegacyCalculationsRequest(_) {
        return _ref.apply(this, arguments);
    };
}();
export function serverSideComputations(data, logger, apolloClient, priceService) {
    return _serverSideComputations.apply(this, arguments);
}
function _serverSideComputations() {
    _serverSideComputations = _async_to_generator(function(data, logger, apolloClient, priceService) {
        var _response_data, _data_dispensary, response, legacyInput, error, _data_dispensary1, legacyOutput, _data_dispensary2;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!data.dispensary || !data.cart || !apolloClient) {
                        ;
                        logger.error('Missing required data for legacy calculations', {
                            hasDispensary: !!data.dispensary,
                            hasCart: !!data.cart,
                            hasApolloClient: !!apolloClient,
                            dispensaryId: (_data_dispensary = data.dispensary) === null || _data_dispensary === void 0 ? void 0 : _data_dispensary.id,
                            priceService: priceService
                        });
                        return [
                            2,
                            {}
                        ];
                    }
                    legacyInput = ecommCalculationsInput(data, priceService);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        handleLegacyCalculationsRequest({
                            apolloClient: apolloClient,
                            logger: logger,
                            legacyInput: legacyInput
                        })
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    logger.error('Error in legacy calculations API call', {
                        dispensaryId: (_data_dispensary1 = data.dispensary) === null || _data_dispensary1 === void 0 ? void 0 : _data_dispensary1.id,
                        priceService: priceService,
                        error: error.message
                    });
                    return [
                        3,
                        4
                    ];
                case 4:
                    legacyOutput = (_response_data = response.data) === null || _response_data === void 0 ? void 0 : _response_data.serverSideCalculations;
                    if (!legacyOutput) {
                        ;
                        logger.error('Empty response from legacy calculations API', {
                            dispensaryId: (_data_dispensary2 = data.dispensary) === null || _data_dispensary2 === void 0 ? void 0 : _data_dispensary2.id,
                            priceService: priceService
                        });
                        return [
                            2,
                            {}
                        ];
                    }
                    return [
                        2,
                        legacyOutput
                    ];
            }
        });
    });
    return _serverSideComputations.apply(this, arguments);
}
